'use client'

import { useRouter } from 'next/navigation'
import { logout } from '@/lib/auth'
import { useCurrentUser } from '@/lib/hooks/use-auth'
import { Button } from '@/components/ui/button'

interface TopbarProps {
  onMenuOpen: () => void
}

export function Topbar({ onMenuOpen }: TopbarProps) {
  const router = useRouter()
  const user = useCurrentUser()

  async function handleLogout() {
    await logout()
    router.push('/login')
    router.refresh()
  }

  return (
    <header className="flex h-14 shrink-0 items-center border-b bg-card px-4 gap-3">
      {/* Hamburger — mobile uniquement */}
      <button
        onClick={onMenuOpen}
        className="md:hidden flex items-center justify-center w-10 h-10 -ml-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted"
        aria-label="Ouvrir le menu"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="2" y1="4" x2="16" y2="4" />
          <line x1="2" y1="9" x2="16" y2="9" />
          <line x1="2" y1="14" x2="16" y2="14" />
        </svg>
      </button>

      <div className="flex-1" />

      {/* Nom complet sur desktop, prénom seul sur mobile */}
      {user && (
        <>
          <span className="hidden sm:inline text-sm text-muted-foreground">
            {user.firstName} {user.lastName}
            <span className="ml-2 rounded bg-muted px-1.5 py-0.5 text-xs font-medium">{user.role}</span>
          </span>
          <span className="sm:hidden text-sm font-medium text-muted-foreground">{user.firstName}</span>
        </>
      )}

      <Button variant="outline" size="sm" onClick={handleLogout}>
        Déconnexion
      </Button>
    </header>
  )
}
